<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-16 19:12:12
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-16 20:23:00
 * @FilePath: /jy-dashboard-web/src/components/productionManagement/map-dttl2.vue
 * @Description: 描述
-->
<template>
  <div class="dttl2">
    <section class="legend" v-for="(item, index) in data" :key="index">
      <i class="icon" :style="{ 'background-image': `url(${item.icon})` }" />
      <span class="name">{{ item.name }}</span>
    </section>
  </div>
</template>

<script>
export default {
  data () {
    return {
      data: [
        { name: '摄像头', icon: '/image/production-management/map/摄像头@2x.png' },
        { name: '气象站', icon: '/image/production-management/map/气象站@2x.png' },
        { name: '水肥系统', icon: '/image/production-management/map/水肥系统@2x.png' },
        { name: 'LED防控', icon: '/image/production-management/map/LED绿色防控系统@2x.png' },
        { name: '智能防霜', icon: '/image/production-management/map/风力智能防霜系统@2x.png' },
        { name: '采茶机', icon: '/image/production-management/map/乘用型采茶机@2x.png' }
      ]
    }
  }
}
</script>

<style lang='scss'>
.dttl2 {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  .legend {
    flex: 1;
    .icon {
      display: block;
      width: 30px;
      height: 41px;
      background-size: cover;
      background-repeat: no-repeat;
      margin: 0 auto;
    }
    .name {
      display: block;
      text-align: center;
      font-size: 10px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      margin-top: 3px;
    }
  }
}
</style>
